import { Navigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { resolvePostLoginRoute } from "../auth/post-login-route";
import HomePage from "./HomePage";
import { PUBLIC_HOME_PATH } from "./public-home-path";

export { PUBLIC_HOME_PATH };

/**
 * Site root: signed-in teachers and students go straight to their workspace.
 * Anonymous visitors see the public landing page (same content as `/home`).
 */
export default function RootRoute() {
  const { status, profile } = useAuth();

  if (status === "authenticated" && profile) {
    if (profile.role === "pending") {
      return <Navigate to="/onboarding" replace />;
    }
    return <Navigate to={resolvePostLoginRoute(profile)} replace />;
  }

  return <HomePage />;
}
